import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'photoswipe/dist/photoswipe.css';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { Row, Col } from 'components';
import { dateTimeFormat } from 'enums';
import { imageHolder, imageHolderWrap } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerDocumentsHistory = function BorrowerDocumentsHistory(_ref) {
  var documents = _ref.documents;
  var deletedDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(function (el) {
    return el === null || el === void 0 ? void 0 : el.deleted_at;
  }).reverse();
  return ___EmotionJSX(Gallery, {
    withDownloadButton: true
  }, ___EmotionJSX(Row, {
    sm: 12,
    md: 3,
    horizontalGap: 16,
    verticalGap: 8
  }, deletedDocuments === null || deletedDocuments === void 0 ? void 0 : deletedDocuments.map(function (el) {
    return ___EmotionJSX(Col, {
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("div", {
      css: imageHolderWrap
    }, ___EmotionJSX("p", null, moment(el === null || el === void 0 ? void 0 : el.deleted_at).format(dateTimeFormat)), ___EmotionJSX(Item, {
      original: el === null || el === void 0 ? void 0 : el.image,
      thumbnail: el === null || el === void 0 ? void 0 : el.image
    }, function (_ref2) {
      var ref = _ref2.ref,
          open = _ref2.open;
      return ___EmotionJSX("div", {
        ref: ref,
        role: "presentation",
        onClick: open,
        css: imageHolder(el === null || el === void 0 ? void 0 : el.image)
      });
    })));
  })));
};

BorrowerDocumentsHistory.propTypes = {
  documents: PropTypes.array
};
export default BorrowerDocumentsHistory;